export const DEFAULT_TAG_COLOR = '#1535c8'

export function slugifyTagName(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    || 'tag'
}

function tagKey(tag) {
  if (tag?.id != null && tag.id !== '') return `id:${tag.id}`
  return `name:${String(tag?.name || tag).trim().toLowerCase()}`
}

function normalizeTagNameKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

function toContactTag(value) {
  if (value === null || value === undefined) return null
  if (typeof value === 'string') {
    const name = value.trim()
    if (!name) return null
    return { id: null, name, slug: slugifyTagName(name), color: null }
  }
  if (typeof value === 'object') {
    const name = String(value.name ?? value.label ?? value.value ?? '').trim()
    if (!name) return null
    return {
      id: value.id ?? value.tag_id ?? null,
      name,
      slug: value.slug ?? slugifyTagName(name),
      color: value.color ?? value.tag_color ?? value.color_hex ?? null,
    }
  }
  return null
}

export function normalizeContactTags(...sources) {
  const seen = new Set()
  const out = []
  const add = (value) => {
    if (value === null || value === undefined) return
    if (Array.isArray(value)) {
      value.forEach(add)
      return
    }
    const tag = toContactTag(value)
    if (!tag) return
    const key = tagKey(tag)
    if (seen.has(key)) return
    seen.add(key)
    out.push(tag)
  }
  sources.forEach(add)
  return out
}

export function enrichContactTags(tags, orgTags = []) {
  const normalizedTags = normalizeContactTags(tags)
  const normalizedOrgTags = normalizeContactTags(orgTags)
  if (!normalizedOrgTags.length) return normalizedTags

  const byId = new Map()
  const byName = new Map()
  normalizedOrgTags.forEach(tag => {
    if (tag.id != null && tag.id !== '') byId.set(String(tag.id), tag)
    byName.set(normalizeTagNameKey(tag.name), tag)
  })

  return normalizedTags.map(tag => {
    const match = tag.id != null && tag.id !== ''
      ? byId.get(String(tag.id))
      : byName.get(normalizeTagNameKey(tag.name))
    if (!match) return tag
    return {
      ...tag,
      id: tag.id ?? match.id,
      slug: tag.slug ?? match.slug,
      color: match.color ?? tag.color ?? null,
    }
  })
}

function hexToRgb(hex) {
  const h = String(hex || '').replace('#', '')
  if (h.length !== 6) return null
  const n = parseInt(h, 16)
  if (Number.isNaN(n)) return null
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}

export function getTagChipStyle(tag, variant = 'inbox') {
  const color = tag?.color || DEFAULT_TAG_COLOR
  const rgb = hexToRgb(color)
  if (!rgb) {
    return variant === 'detail'
      ? { className: 'bg-[#e8ecff] text-[#1535c8]' }
      : { background: '#e8ecff', color: '#1535c8' }
  }
  const bg = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.12)`
  if (variant === 'detail') {
    return { style: { backgroundColor: bg, color } }
  }
  return { background: bg, color }
}

export function tagNamesMatch(a, b) {
  return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase()
}
